export const orderItemsConstants = {
  FETCH_COUNT_REQUEST: 'ORDER_ITEMS_COUNT_FETCH_REQUEST',
  FETCH_COUNT_SUCCESS: 'ORDER_ITEMS_COUNT_FETCH_SUCCESS',
  FETCH_COUNT_FAILURE: 'ORDER_ITEMS_COUNT_FETCH_FAILURE',
  FETCH_REQUEST: 'ORDER_ITEMS_FETCH_REQUEST',
  FETCH_SUCCESS: 'ORDER_ITEMS_FETCH_SUCCESS',
  FETCH_FAILURE: 'ORDER_ITEMS_FETCH_FAILURE',
};
